import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserInfo } from 'src/app/models/apis/login';

@Injectable({
	providedIn: 'root',
})
export class AuthService {
	USER_KEY = 'user';

	private internalToken: string | null = null;
	private tokenSubject = new BehaviorSubject<string | null>(null);

	token$ = this.tokenSubject.asObservable();
	isAuthenticated$ = this.token$.pipe(map(token => !!token));

	constructor() {}

	setInternalToken(token: string): void {
		this.internalToken = token;
		this.tokenSubject.next(token);
	}

	getToken(): string | null {
		return this.internalToken;
	}

	clearToken(): void {
		this.internalToken = null;
		this.tokenSubject.next(null);
	}

	setUserLogged(userInformation: UserInfo) {
		localStorage.setItem(this.USER_KEY, JSON.stringify(userInformation));
	}

	getUserLogged(): UserInfo {
		const loggedUser = localStorage.getItem(this.USER_KEY);
		if (loggedUser) {
			return JSON.parse(loggedUser);
		}
		return null;
	}
}
